export default __webpack_public_path__ + "static/media/x.e264d1b7.svg";